// extracted by mini-css-extract-plugin
export default {"El":"App_El__IqvGa"};